import React from 'react';
import { Button, Panel } from 'react-bootstrap';
import { SortableElement } from 'react-sortable-hoc';

import SortHandle from './SortHandle';
import { stripTags } from '../../../../../utils/helper';

const SortItem = SortableElement(({ item, hideHandle, onEditReply }) => (
  <Panel.Body key={item.id} className="replies-body">
    <div className="replies-list__row">
      {!hideHandle && <div className="replies-list__cell replies-list__handle">{!item.default && <SortHandle />}</div>}
      <div className="replies-list__cell replies-list__title">{item.title}</div>
      <div className="replies-list__cell replies-list__body">
        <div>{stripTags(item.body, ' ')}</div>
      </div>
      <div className="replies-list__cell replies-list__delete">
        <Button bsSize="xsmall" className="edit-action" onClick={() => onEditReply(item)}>
          Edit
        </Button>
      </div>
    </div>
  </Panel.Body>
));

export default SortItem;
